import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "nav-item text-nowrap"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 1,
    class: "nav-item dropdown"
};
const _hoisted_4 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    return (!_ctx.menuItem.children || _ctx.menuItem.children.length === 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
            _createVNode(_component_g_link, {
                src: _ctx.menuItem.actionCommand,
                target: _ctx.menuItem.actionTarget,
                class: "nav-link"
            }, {
                default: _withCtx(() => [
                    (_ctx.menuItem.iconUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.menuItem.iconUrl
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.getMenuItemCaption(_ctx.menuItem)), 1)
                ]),
                _: 1
            }, 8, ["src", "target"])
        ]))
        : (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createElementVNode("a", {
                class: "nav-link dropdown-toggle show text-nowrap",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.onShowSubMenu && _ctx.onShowSubMenu(...args))),
                id: 'navbarDropdown_' + _ctx.menuItem.menuID,
                role: "button"
            }, _toDisplayString(_ctx.getMenuItemCaption(_ctx.menuItem)), 9, _hoisted_4)
        ]));
}
